// latest: zhangmyh 2017-8-22 3:01 PM
import { Model } from 'common'
import './indicator'
Model.define('templatelib_field_certification', {
  proxy: {
    post: '/cpu-supplymgr/templet/saveFieldCertAndEvalTemp',
    get: '/cpu-supplymgr/templet/oneFieldCertAndEvalTemp'
  },
  meta: {
    id: '',
    classId: '',
    className: '',
    code: '',
    name: {
      type: 'string',
      required: true,
      nullMsg: '请填选择模板名称',
      maxLength: '100',
      maxLengthMsg: '模板名称，最大长度不得超过50个汉字'
    },
    createOrgId: '',
    createOrgName: '',
    creator: '',
    creatorName: '',
    description: {
      type: 'string',
      required: true,
      nullMsg: '请填选择模板描述',
      maxLength: '2000',
      maxLengthMsg: '模板描述，最大长度不得超过1000个汉字'
    },
    enableStatus: '',
    modifier: '',
    modifierName: '',
    templetId: '',
    templetType: '',
    another: '', // 1 新版本 0 非新版本
    newest: '', // 最新版本
    newestId: '', // 最新版本ID
    versionNo: '', // 版本号
    createTime: '',
    isGlobal: '' // 1 集团级模板 0 组织级模板
  },
  associations: {
    indicators: { // 代理子表
      type: 'hasMany', // hasMany
      model: 'templatelib_field_certification.indicator'
    }
  }
})

export default Model.create('templatelib_field_certification')



// WEBPACK FOOTER //
// ./src/data/model/tplFieldCertification/index.js